import { HStack, Spacer, Text } from "@chakra-ui/react";
import { MessageFragment } from "gql/graphql";
import UserName from "modules/_shared/user-name";
import moment from "moment";
import React, { memo } from "react";
import colors from "app/colors";
import { MESSAGE_CALENDAR_FORMATS } from "modules/utils/Constants";

interface IProps {
  message: MessageFragment;
}

const MessageUserNameDateHeader: React.FC<IProps> = ({ message }) => (
  <HStack w="full" pt={3}>
    <Text
      fontWeight={600}
      fontSize={14}
      color={message.deleted ? colors.grayMain : colors.blackSecondary}
    >
      <UserName userId={message.createdUserId} />
    </Text>
    <Spacer />
    <Text
      color={colors.grayMain}
      fontSize={12}
      fontWeight={400}
      whiteSpace="nowrap"
    >
      {moment(message.createTime).calendar(MESSAGE_CALENDAR_FORMATS)}
    </Text>
  </HStack>
);

export default memo(MessageUserNameDateHeader);
